import { api } from "./api";

export const authService = {
  login(credentials) {
    return api.post("/api-token-auth", credentials);
  },
};

export default authService;
